<div class="code-input__group" role="group" [attr.aria-label]="ariaLabel">
  @for (digit of digits; track $index) {
    <input
      #cell
      class="code-input__cell"
      type="text"
      inputmode="numeric"
      maxlength="1"
      [value]="digit"
      [disabled]="disabled"
      [attr.autocomplete]="$index === 0 ? 'one-time-code' : 'off'"
      [attr.aria-label]="'Digit ' + ($index + 1) + ' of ' + length"
      (input)="onInput_setDigit($index, $event)"
      (keydown)="onKeydown_navigate($index, $event)"
      (paste)="onPaste_distribute($event)"
      (blur)="onBlur()" />
  }
</div>
